import React, { cloneElement } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import ModalBox from '../modal/modal-box'
import { MultiStepBar } from '../multi-step-bar'

import styles from './wizard.module.css'

const statelessPropTypes = {
    activeStep: PropTypes.number.isRequired,
    classNames: PropTypes.shape({
        contentClassName: PropTypes.string,
        headerClassName: PropTypes.string,
        modalClassName: PropTypes.string,
        titleClassName: PropTypes.string
    }),
    // eslint-disable-next-line react/forbid-prop-types
    model: PropTypes.object,
    onClose: PropTypes.func,
    setStep: PropTypes.func.isRequired,
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.element,
            page: PropTypes.element.isRequired,
            subtitle: PropTypes.string.isRequired,
            title: PropTypes.string
        })
    ).isRequired,
    title: PropTypes.string,
    updateModel: PropTypes.func
}

const defaultProps = {
    activeStep: 0,
    classNames: {},
    model: null,
    onClose: Function.prototype,
    setStep: Function.prototype,
    steps: [],
    updateModel: Function.prototype
}

function Wizard({
    activeStep,
    className,
    classNames,
    model,
    onClose,
    setStep,
    steps,
    title,
    updateModel,
    ...modalProps
}) {
    if (!steps.length) {
        return null
    }

    const currentStep = steps[activeStep]
    const activeView = cloneElement(currentStep.page, { activeStep, model, onClose, setStep, steps, updateModel })
    const { headerClassName, modalClassName, titleClassName } = classNames

    const classes = {
        content: cx(styles['content'], className, 't3sel-wizard-content'),
        header: cx(styles['header'], headerClassName, 't3sel-wizard-header'),
        modal: cx(styles['modal'], modalClassName, 't3sel-wizard-modal'),
        modalOverlay: cx(styles['modal-overlay'], 't3sel-wizard-modal-overlay'),
        stepNumber: cx(styles['step-number'], 't3sel-wizard-step-number'),
        title: cx(styles['title'], titleClassName, 't3sel-wizard-title')
    }

    return (
        <ModalBox isOpen={true} {...modalProps} className={classes.modal} overlayClassName={classes.modalOverlay}>
            <header className={classes.header}>
                <h2 className={classes.title}>{currentStep.title || title}</h2>
                <MultiStepBar
                    steps={steps.map(step => ({ ...step, caption: step.subtitle || step.title }))}
                    activeStep={activeStep}
                />
            </header>
            <main className={classes.content}>{activeView}</main>
        </ModalBox>
    )
}

Wizard.defaultProps = defaultProps
Wizard.propTypes = statelessPropTypes

export { Wizard }
